class ProductSection extends HTMLElement {
  constructor() {
    super();

    /*
      While a new color loads, STOQ draws its Notify me button on the old section
      (it watches the ?variant= change), the section is then swapped, and the
      button is drawn again. Hiding STOQ's button for the length of the swap and
      fading it in once at the end means only the final state is ever seen.
    */
    if (!document.getElementById("product-section-swap-style")) {
      const style = document.createElement("style");
      style.id = "product-section-swap-style";
      style.textContent =
        ".restock-rocket-button-container { transition: opacity 0.2s ease; }" +
        "html.is-switching-variant .restock-rocket-button-container { opacity: 0 !important; transition: none; }";
      document.head.appendChild(style);
    }

    /* Each color click gets a number; only the latest one is allowed to land. */
    let latestRequest = 0;

    document.addEventListener("productformvariants:change", (event) => {
      render(event.detail.variant);
    });

    /*
      STOQ exposes its own render call (window._Stoq.renderButtonForVariant),
      which takes the variant id and redraws the button against the new product
      form. Guarded so a change on STOQ's side can never break variant switching.
    */
    function restoreStoqButton(variantId) {
      try {
        if (window._Stoq && typeof window._Stoq.renderButtonForVariant === "function") {
          window._Stoq.renderButtonForVariant(variantId);
        }
      } catch (error) {
        console.warn("[ProductSection] STOQ button could not be restored", error);
      }
    }

    function finishSwitch(requestId) {
      /* A short pause lets STOQ finish drawing before the button fades in. */
      setTimeout(() => {
        if (requestId === latestRequest) {
          document.documentElement.classList.remove("is-switching-variant");
        }
      }, 150);
    }

    function render(variant) {
      const container = document.querySelector("product-section");
      if (!container) return;

      const requestId = ++latestRequest;
      document.documentElement.classList.add("is-switching-variant");

      const section_url = `${location.pathname}/?variant=${variant.id}&section_id=${container.dataset.sectionId}`;

      return fetch(section_url)
        .then((response) => response.text())
        .then((response) => {
          /* A newer color was clicked while this one loaded; let that one win. */
          if (requestId !== latestRequest) return;

          const parser = new DOMParser();
          const doc = parser.parseFromString(response, "text/html");

          const section = doc.querySelector("product-section");
          const current = document.querySelector("product-section");
          if (!section || !current) {
            finishSwitch(requestId);
            return;
          }

          current.replaceWith(section);

          /* Wait one frame so the new form is laid out before STOQ attaches to it. */
          requestAnimationFrame(() => {
            restoreStoqButton(variant.id);
            finishSwitch(requestId);
          });
        })
        .catch((error) => {
          console.warn("[ProductSection] Section could not be loaded", error);
          if (requestId === latestRequest) {
            document.documentElement.classList.remove("is-switching-variant");
          }
        });
    }
  }
}

customElements.define("product-section", ProductSection);